(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capri-vibe-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const productAnchorHash = '#shop-now';

    const getProductRoot = (page) => page.querySelector('[id^="MainProduct-"]');
    let productScrollRequest = 0;

    const ensureProductAnchor = (productRoot) => {
      const existingAnchor = document.getElementById(productAnchorHash.slice(1));
      if (existingAnchor) return existingAnchor;

      const anchor = document.createElement('span');
      anchor.id = productAnchorHash.slice(1);
      anchor.dataset.cvvShopAnchor = '';
      anchor.setAttribute('aria-hidden', 'true');
      productRoot.prepend(anchor);
      return anchor;
    };

    const syncProductScrollLinks = (page) => {
      const productRoot = getProductRoot(page);
      if (!productRoot) return;

      ensureProductAnchor(productRoot);
      page.querySelectorAll('[data-cvv-scroll-product]').forEach((link) => {
        link.setAttribute('href', productAnchorHash);
      });
    };

    const updateProductHash = () => {
      if (window.location.hash === productAnchorHash) return;

      window.history.replaceState(
        window.history.state,
        '',
        `${window.location.pathname}${window.location.search}${productAnchorHash}`
      );
    };

    const isVisibleProductTarget = (target) => {
      if (!target) return false;

      const targetRect = target.getBoundingClientRect();
      const targetStyle = window.getComputedStyle(target);

      return (
        targetRect.width > 0 &&
        targetRect.height > 0 &&
        targetStyle.display !== 'none' &&
        targetStyle.visibility !== 'hidden'
      );
    };

    const isSizeOptionGroup = (group) => {
      const label = group.querySelector('.form__label, .name-option')?.textContent || '';
      const dataName = group.querySelector('[data-name]')?.getAttribute('data-name') || '';
      const controlName =
        group.querySelector('select')?.getAttribute('name') ||
        group.querySelector('input')?.getAttribute('name') ||
        '';

      return /\bsize\b/i.test(`${label} ${dataName} ${controlName}`);
    };

    const getProductSizePicker = (productRoot) => {
      const renderedOptionGroups = Array.from(
        productRoot.querySelectorAll('.globo-swatch-product-detail .swatch--gl')
      );
      const nativeOptionGroups = Array.from(
        productRoot.querySelectorAll(
          'variant-selects .product-form__input, variant-radios .product-form__input'
        )
      );

      return (
        renderedOptionGroups.find(
          (group) => isVisibleProductTarget(group) && isSizeOptionGroup(group)
        ) ||
        nativeOptionGroups.find(
          (group) => isVisibleProductTarget(group) && isSizeOptionGroup(group)
        )
      );
    };

    const getProductOverviewMedia = (productRoot) => {
      const mediaItems = Array.from(
        productRoot.querySelectorAll('.product__media-list .product__media-item')
      );

      return (
        mediaItems.find(
          (item) => item.classList.contains('is-active') && isVisibleProductTarget(item)
        ) ||
        mediaItems.find((item) => isVisibleProductTarget(item))
      );
    };

    const getProductOverviewTop = (mediaTarget) => {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const mediaHeight = mediaTarget.getBoundingClientRect().height;

      return Math.max(0, (viewportHeight - mediaHeight) / 2);
    };

    const getProductInfoLandingTop = (productRoot, preferredTop) => {
      const wrapper = productRoot.querySelector('.product__info-wrapper');
      const sizeTarget = getProductSizePicker(productRoot);
      if (!wrapper || !sizeTarget) return preferredTop;

      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const wrapperRect = wrapper.getBoundingClientRect();
      const sizeRect = sizeTarget.getBoundingClientRect();
      const sizeBottomOffset = sizeRect.bottom - wrapperRect.top;
      const maximumTop = viewportHeight - 20 - sizeBottomOffset;

      return Math.max(0, Math.min(preferredTop, maximumTop));
    };

    const alignProductOverview = (productRoot, pinSticky = true) => {
      const mediaTarget = getProductOverviewMedia(productRoot);
      if (!mediaTarget) return false;

      const overviewTop = getProductOverviewTop(mediaTarget);
      const infoTop = getProductInfoLandingTop(productRoot, overviewTop);
      const mediaRect = mediaTarget.getBoundingClientRect();
      const adjustment = mediaRect.top - overviewTop;

      setProductInfoStickyLanding(productRoot, infoTop, pinSticky);
      if (Math.abs(adjustment) > 1) {
        window.scrollBy({ top: adjustment, behavior: 'auto' });
      }

      return true;
    };

    const alignProductTarget = (target) => {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const topBoundary = 112;
      const bottomBoundary = viewportHeight - 28;
      const targetRect = target.getBoundingClientRect();
      const availableHeight = bottomBoundary - topBoundary;
      let adjustment;

      if (targetRect.height > availableHeight) {
        adjustment = targetRect.top - topBoundary;
      } else {
        const centeredTop = topBoundary + (availableHeight - targetRect.height) / 2;
        adjustment = targetRect.top - centeredTop;
      }

      if (Math.abs(adjustment) > 1) {
        window.scrollBy({ top: adjustment, behavior: 'auto' });
      }
    };

    const settleProductScroll = (productRoot, fallbackTarget) => {
      const request = ++productScrollRequest;
      const startedAt = performance.now();
      let previousScrollY = window.scrollY;
      let stableFrames = 0;

      const checkPosition = () => {
        if (request !== productScrollRequest || !productRoot.isConnected) return;

        const currentScrollY = window.scrollY;
        stableFrames = Math.abs(currentScrollY - previousScrollY) < 0.5 ? stableFrames + 1 : 0;
        previousScrollY = currentScrollY;

        if (stableFrames < 4 && performance.now() - startedAt < 1600) {
          window.requestAnimationFrame(checkPosition);
          return;
        }

        const alignLatestTarget = () => {
          if (productStickyDesktop.matches && alignProductOverview(productRoot)) return;

          const latestTarget = getProductSizePicker(productRoot) || fallbackTarget;
          if (latestTarget?.isConnected) alignProductTarget(latestTarget);
        };

        alignLatestTarget();
        window.requestAnimationFrame(() => {
          alignLatestTarget();
          window.requestAnimationFrame(() => {
            alignLatestTarget();
            releaseProductInfoStickyLanding(productRoot);
          });
        });
      };

      window.requestAnimationFrame(checkPosition);
    };

    const scrollToProduct = (page) => {
      const productRoot = getProductRoot(page);
      if (!productRoot) return false;

      const sizeTarget = getProductSizePicker(productRoot);
      const fallbackTarget =
        productRoot.querySelector('.product__info-container') ||
        productRoot.querySelector('.product__info-wrapper') ||
        productRoot;
      const overviewTarget = productStickyDesktop.matches
        ? getProductOverviewMedia(productRoot)
        : undefined;
      const target = overviewTarget || sizeTarget || fallbackTarget;

      if (overviewTarget) {
        const overviewTop = getProductOverviewTop(overviewTarget);
        const infoTop = getProductInfoLandingTop(productRoot, overviewTop);
        const destination = window.scrollY + overviewTarget.getBoundingClientRect().top - overviewTop;

        setProductInfoStickyLanding(productRoot, infoTop);
        window.scrollTo({
          top: Math.max(0, destination),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
        settleProductScroll(productRoot, fallbackTarget);
        return true;
      }

      target.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: sizeTarget ? 'center' : 'start'
      });
      settleProductScroll(productRoot, fallbackTarget);
      return true;
    };

    const initProductScroll = (page) => {
      syncProductScrollLinks(page);
      if (page.dataset.cvvProductScrollReady === 'true') return;

      page.dataset.cvvProductScrollReady = 'true';
      page.addEventListener('click', (event) => {
        const link = event.target?.closest?.('[data-cvv-scroll-product]');
        if (!link || !page.contains(link)) return;
        if (!getProductRoot(page)) return;

        event.preventDefault();
        event.stopPropagation();
        if (scrollToProduct(page)) updateProductHash();
      }, true);

      if (window.location.hash === productAnchorHash) {
        window.requestAnimationFrame(() => scrollToProduct(page));
      }
    };

    const productStickyDesktop = window.matchMedia('(min-width: 960px)');
    const productStickyEntries = new Set();
    const productStickyTopGap = 96;
    const productStickyBottomGap = 20;
    let productStickyScrollY = window.scrollY;
    let productStickyFrame;

    const clampProductStickyTop = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

    const syncProductInfoSticky = (entry, scrollDelta = 0) => {
      const { productRoot, wrapper } = entry;

      if (!productStickyDesktop.matches) {
        entry.active = false;
        entry.currentTop = productStickyTopGap;
        entry.landingPinned = false;
        wrapper.style.removeProperty('--cvv-product-info-sticky-top');
        return;
      }

      const product = productRoot.querySelector('.product') || productRoot;
      const productRect = product.getBoundingClientRect();
      const wrapperHeight = wrapper.getBoundingClientRect().height;
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      if (entry.landingPinned) {
        entry.active = true;
        entry.currentTop = entry.landingTop;
        wrapper.style.setProperty('--cvv-product-info-sticky-top', `${Math.round(entry.currentTop)}px`);
        return;
      }

      const minimumTop = Math.min(
        productStickyTopGap,
        viewportHeight - wrapperHeight - productStickyBottomGap
      );
      const active = productRect.top < viewportHeight && productRect.bottom > 0;

      if (!active) {
        entry.active = false;
        entry.currentTop = productRect.top >= viewportHeight ? productStickyTopGap : minimumTop;
      } else if (!entry.active) {
        entry.active = true;
        entry.currentTop = scrollDelta < 0 ? minimumTop : productStickyTopGap;
      } else {
        entry.currentTop = clampProductStickyTop(
          entry.currentTop - scrollDelta,
          minimumTop,
          productStickyTopGap
        );
      }

      wrapper.style.setProperty('--cvv-product-info-sticky-top', `${Math.round(entry.currentTop)}px`);
    };

    const setProductInfoStickyLanding = (productRoot, top, pinned = true) => {
      const entry = Array.from(productStickyEntries).find(
        (candidate) => candidate.productRoot === productRoot
      );
      if (!entry) return;

      entry.active = true;
      entry.currentTop = top;
      entry.landingPinned = pinned;
      entry.landingTop = top;
      entry.wrapper.style.setProperty('--cvv-product-info-sticky-top', `${Math.round(top)}px`);
      productStickyScrollY = window.scrollY;
    };

    const releaseProductInfoStickyLanding = (productRoot) => {
      const entry = Array.from(productStickyEntries).find(
        (candidate) => candidate.productRoot === productRoot
      );
      if (!entry) return;

      entry.landingPinned = false;
      productStickyScrollY = window.scrollY;
    };

    const updateProductInfoSticky = () => {
      productStickyFrame = undefined;
      const scrollY = window.scrollY;
      const scrollDelta = scrollY - productStickyScrollY;
      productStickyScrollY = scrollY;

      productStickyEntries.forEach((entry) => {
        if (!entry.wrapper.isConnected || !entry.productRoot.isConnected) {
          entry.observer.disconnect();
          productStickyEntries.delete(entry);
          return;
        }

        syncProductInfoSticky(entry, scrollDelta);
      });
    };

    const requestProductInfoStickySync = () => {
      if (productStickyFrame) return;
      productStickyFrame = window.requestAnimationFrame(updateProductInfoSticky);
    };

    const initProductInfoSticky = (page) => {
      const productRoot = getProductRoot(page);
      const wrapper = productRoot?.querySelector('.product__info-wrapper');
      if (!productRoot || !wrapper || wrapper.dataset.cvvProductInfoStickyReady === 'true') return;

      const entry = {
        active: false,
        currentTop: productStickyTopGap,
        landingPinned: false,
        landingTop: productStickyTopGap,
        observer: undefined,
        productRoot,
        wrapper
      };

      wrapper.dataset.cvvProductInfoStickyReady = 'true';
      entry.observer = new ResizeObserver(requestProductInfoStickySync);
      entry.observer.observe(wrapper);
      productStickyEntries.add(entry);
      syncProductInfoSticky(entry);
    };

    const releaseProductInfoSticky = (scope) => {
      productStickyEntries.forEach((entry) => {
        if (scope !== entry.wrapper && !scope.contains(entry.wrapper)) return;
        entry.observer.disconnect();
        productStickyEntries.delete(entry);
      });
    };

    const initPurchaseOptionOrder = (page) => {
      const productRoot = getProductRoot(page);
      if (!productRoot) return;

      const syncTopLevelVariants = () => {
        const variantPicker = productRoot.querySelector('variant-selects, variant-radios');
        const globo = productRoot.querySelector('.globo-swatch-product-detail');
        const pickerEnabled = !!variantPicker;

        productRoot.classList.toggle('cvv-hide-top-variants', !pickerEnabled);
        productRoot.classList.toggle('cvv-use-globo-variants', pickerEnabled && !!globo);

        if (!pickerEnabled || !globo) return;

        const kaching =
          productRoot.querySelector('kaching-bundle') ||
          productRoot.querySelector('.kaching-bundles');
        if (!kaching?.parentNode) return;

        const globoAfterKaching = !!(
          globo.compareDocumentPosition(kaching) & Node.DOCUMENT_POSITION_PRECEDING
        );
        if (globoAfterKaching) {
          kaching.parentNode.insertBefore(globo, kaching);
        }
      };

      const positionPurchaseOptions = () => {
        syncTopLevelVariants();

        const guide =
          page.querySelector('.cvv-size-guide') ||
          productRoot.querySelector('.cvv-size-guide');
        const productForm = productRoot.querySelector('product-form');
        if (guide && productForm?.parentNode) {
          if (
            guide.nextElementSibling !== productForm ||
            guide.parentNode !== productForm.parentNode
          ) {
            productForm.parentNode.insertBefore(guide, productForm);
          }
        }
      };

      positionPurchaseOptions();

      if (page.dataset.cvvPurchaseOptionOrderReady !== 'true') {
        page.dataset.cvvPurchaseOptionOrderReady = 'true';
        const positionObserver = new MutationObserver(positionPurchaseOptions);
        positionObserver.observe(productRoot, { childList: true, subtree: true });
        window.setTimeout(() => positionObserver.disconnect(), 15000);
      }
    };

    const initSizeGuide = (page) => {
      const productRoot = getProductRoot(page);
      initPurchaseOptionOrder(page);

      page.querySelectorAll('[data-cvv-size-guide]').forEach((button) => {
        if (button.dataset.cvvSizeGuideReady === 'true') return;
        button.dataset.cvvSizeGuideReady = 'true';

        button.addEventListener('click', (event) => {
          if (typeof window.cvvOpenSizeGuide === 'function') {
            event.preventDefault();
            window.cvvOpenSizeGuide();
          }
        });
      });

      page.querySelectorAll('a[href="#cvv-sg-open"]').forEach((link) => {
        if (link.dataset.cvvSizeGuideLinkReady === 'true') return;
        link.dataset.cvvSizeGuideLinkReady = 'true';

        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (typeof window.cvvOpenSizeGuide === 'function') {
            window.cvvOpenSizeGuide();
            return;
          }
          productRoot?.querySelector('#cvv-sg-open')?.click();
        });
      });
    };

    const syncHeroVideos = (root) => {
      const videos = Array.from(root.querySelectorAll('[data-cvv-autoplay-video]'));
      if (!videos.length) return;

      videos.forEach((video) => video.pause());
      if (reducedMotion.matches) return;

      const visibleVideo = videos.find((video) => {
        const style = window.getComputedStyle(video.closest('.cvv-hero__media-item'));
        return style.display !== 'none';
      });

      if (visibleVideo) {
        visibleVideo.muted = true;
        visibleVideo.play().catch(() => {});
      }
    };

    const syncHeroLayout = (root) => {
      const inner = root.querySelector('.cvv-hero__inner');
      if (!inner) return;

      if (!window.matchMedia('(min-width: 960px)').matches) {
        inner.style.removeProperty('--cvv-hero-media-size');
        return;
      }

      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const documentTop = root.getBoundingClientRect().top + window.scrollY;
      const availableHeight = Math.floor(viewportHeight - documentTop);
      const halfWidth = Math.floor(inner.clientWidth / 2);
      const mediaSize = availableHeight > 0 ? Math.min(halfWidth, availableHeight) : halfWidth;

      inner.style.setProperty('--cvv-hero-media-size', `${mediaSize}px`);
    };

    let heroLayoutFrame;
    const requestHeroLayoutSync = () => {
      if (heroLayoutFrame) window.cancelAnimationFrame(heroLayoutFrame);
      heroLayoutFrame = window.requestAnimationFrame(() => {
        document.querySelectorAll('[data-cvv-hero]').forEach(syncHeroLayout);
        heroLayoutFrame = undefined;
      });
    };

    const initProductLightbox = (page, root) => {
      const productRoot = page.querySelector('[id^="MainProduct-"]');
      if (!productRoot) return;

      const modal = document.getElementById(`ProductModal-${productRoot.dataset.section}`);
      if (!modal || modal.dataset.cvvLightboxReady === 'true') return;

      const dialog = modal.querySelector('.product-media-modal__dialog');
      const content = modal.querySelector('.product-media-modal__content');
      if (!dialog || !content) return;

      const slides = Array.from(content.children).filter((item) => item.dataset.mediaId);
      if (!slides.length) return;

      modal.dataset.cvvLightboxReady = 'true';
      modal.classList.add('cvv-product-lightbox');

      const controls = document.createElement('div');
      controls.className = 'cvv-lightbox__controls';
      controls.innerHTML = `
        <button class="cvv-lightbox__button" type="button" data-cvv-lightbox-previous>
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m14.5 5-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <span class="cvv-lightbox__counter" data-cvv-lightbox-counter aria-live="polite"></span>
        <button class="cvv-lightbox__button" type="button" data-cvv-lightbox-next>
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m9.5 5 7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      `;
      dialog.appendChild(controls);

      const previousButton = controls.querySelector('[data-cvv-lightbox-previous]');
      const nextButton = controls.querySelector('[data-cvv-lightbox-next]');
      const counter = controls.querySelector('[data-cvv-lightbox-counter]');
      previousButton.setAttribute('aria-label', root.dataset.cvvPreviousLabel);
      nextButton.setAttribute('aria-label', root.dataset.cvvNextLabel);
      let activeIndex = 0;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        window.pauseAllMedia?.();

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        const activeSlide = slides[activeIndex];
        const deferredMedia = activeSlide.matches('deferred-media')
          ? activeSlide
          : activeSlide.querySelector('deferred-media');
        deferredMedia?.loadContent?.();
        counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      const syncActiveSlide = () => {
        const selectedIndex = slides.findIndex((slide) => slide.classList.contains('active'));
        showSlide(selectedIndex >= 0 ? selectedIndex : 0);
      };

      previousButton.addEventListener('click', () => showSlide(activeIndex - 1));
      nextButton.addEventListener('click', () => showSlide(activeIndex + 1));
      controls.addEventListener('pointerup', (event) => event.stopPropagation());
      content.addEventListener('pointerup', (event) => event.stopPropagation());

      modal.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(activeIndex + 1);
        }
      });

      new MutationObserver(() => {
        if (modal.hasAttribute('open')) syncActiveSlide();
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    };

    const initStickyAtc = (root, page) => {
      const sticky = root.querySelector('[data-cvv-sticky-atc]');
      const stickyButton = root.querySelector('[data-cvv-sticky-button]');
      const stickyPrice = root.querySelector('[data-cvv-sticky-price]');
      const productRoot = page.querySelector('[id^="MainProduct-"]');
      if (!sticky || !stickyButton || !productRoot || sticky.dataset.cvvReady === 'true') return;

      const primaryButton = productRoot.querySelector('product-form .product-form__submit');
      if (!primaryButton) return;
      sticky.dataset.cvvReady = 'true';

      const addLabel = sticky.dataset.addLabel;
      const soldOutLabel = sticky.dataset.soldOutLabel;
      const footer = document.querySelector('footer');

      const syncState = () => {
        const price = productRoot.querySelector('.price__sale .price-item--last, .price > .price__container .price-item--regular');
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
        stickyButton.disabled = primaryButton.disabled;
        stickyButton.textContent = primaryButton.disabled ? soldOutLabel : addLabel;
      };

      let ticking = false;
      const updateVisibility = () => {
        ticking = false;
        const mobile = window.matchMedia('(max-width: 959px)').matches;
        const purchasePassed = primaryButton.getBoundingClientRect().bottom < 0;
        const footerReached = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const show = mobile && purchasePassed && !footerReached;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };

      const requestVisibilityUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateVisibility);
      };

      stickyButton.addEventListener('click', () => {
        if (primaryButton.disabled) {
          scrollToProduct(page);
          return;
        }
        primaryButton.click();
      });

      new MutationObserver(syncState).observe(productRoot, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });

      window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
      window.addEventListener('resize', () => {
        syncHeroVideos(root);
        requestVisibilityUpdate();
      });
      syncState();
      updateVisibility();
    };

    const initSmoothProductAccordions = (page) => {
      const productRoot = getProductRoot(page);
      if (!productRoot) return;

      productRoot.querySelectorAll('.product__accordion details').forEach((details) => {
        if (details.dataset.cvvAccordionReady === 'true') return;

        const summary = details.querySelector(':scope > summary');
        const content = details.querySelector(':scope > .accordion__content');
        if (!summary || !content) return;

        details.dataset.cvvAccordionReady = 'true';
        let animation = null;

        const finishAnimation = (isOpen) => {
          details.open = isOpen;
          details.classList.remove('is-cvv-animating', 'is-cvv-closing');
          details.style.height = '';
          details.style.overflow = '';
          animation = null;
        };

        summary.addEventListener('click', (event) => {
          if (reducedMotion.matches || typeof details.animate !== 'function') return;
          event.preventDefault();

          if (animation) {
            const previousAnimationWasClosing = details.classList.contains('is-cvv-closing');
            animation.oncancel = null;
            animation.cancel();
            finishAnimation(!previousAnimationWasClosing);
          }

          const isClosing = details.open;
          const startHeight = details.offsetHeight;

          if (!isClosing) details.open = true;

          const endHeight = isClosing ? summary.offsetHeight : details.scrollHeight;
          const distance = Math.abs(endHeight - startHeight);
          const duration = Math.min(360, 220 + distance * 0.16);

          details.classList.add('is-cvv-animating');
          details.classList.toggle('is-cvv-closing', isClosing);
          details.style.height = `${startHeight}px`;
          details.style.overflow = 'hidden';

          animation = details.animate(
            {
              height: [`${startHeight}px`, `${endHeight}px`],
            },
            {
              duration,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            }
          );

          animation.onfinish = () => finishAnimation(!isClosing);
          animation.oncancel = () => {
            details.classList.remove('is-cvv-animating', 'is-cvv-closing');
            details.style.height = '';
            details.style.overflow = '';
            animation = null;
          };
        });
      });
    };

    const initCountryFlags = (page) => {
      page.querySelectorAll('.cvv-purchase-delivery[data-cvv-country-code]').forEach((delivery) => {
        const countryCode = (window.Shopify?.country || delivery.dataset.cvvCountryCode || '').trim().toUpperCase();
        if (!countryCode || countryCode.length !== 2) return;

        const flag = delivery.querySelector('[data-cvv-country-flag]');
        const countryName = delivery.querySelector('[data-cvv-country-name]');
        if (flag) {
          flag.textContent = Array.from(countryCode)
            .map((letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)))
            .join('');
        }

        if (countryName && window.Intl?.DisplayNames) {
          try {
            const locale = document.documentElement.lang || 'en';
            countryName.textContent = new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode);
          } catch (error) {
            // Keep Shopify's server-rendered country name as the fallback.
          }
        }
      });
    };

    const init = (scope = document) => {
      const page = scope.closest?.('.cvv-page') || scope.querySelector?.('.cvv-page') || document.querySelector('.cvv-page');
      if (!page) return;

      initProductScroll(page);
      initProductInfoSticky(page);
      initSizeGuide(page);
      initSmoothProductAccordions(page);
      initCountryFlags(page);

      page.querySelectorAll('[data-cvv-hero]').forEach((root) => {
        syncHeroLayout(root);
        syncHeroVideos(root);
        initProductLightbox(page, root);
        initStickyAtc(root, page);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    reducedMotion.addEventListener?.('change', () => init());
    productStickyDesktop.addEventListener?.('change', requestProductInfoStickySync);
    window.addEventListener('scroll', requestProductInfoStickySync, { passive: true });
    window.addEventListener('load', requestHeroLayoutSync, { once: true });
    window.addEventListener('load', requestProductInfoStickySync, { once: true });
    window.addEventListener('resize', requestHeroLayoutSync, { passive: true });
    window.addEventListener('resize', requestProductInfoStickySync, { passive: true });
    window.visualViewport?.addEventListener('resize', requestHeroLayoutSync, { passive: true });
    window.visualViewport?.addEventListener('resize', requestProductInfoStickySync, { passive: true });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => releaseProductInfoSticky(event.target));
    document.addEventListener('shopify:section:reorder', requestHeroLayoutSync);
    document.addEventListener('shopify:section:reorder', requestProductInfoStickySync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capri-vibe-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cvv-variant-swatches')) {
    class CvvVariantSwatches extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.preloadImages = this.preloadImages.bind(this);
        this.card = null;
        this.hasPreloadedImages = false;
        this.imageSwitchId = 0;
        this.preloadedImages = new Map();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.card = this.closest('.cvv-product-card');

        if (this.card) {
          this.card.addEventListener('pointerenter', this.preloadImages, { once: true });
          this.card.addEventListener('focusin', this.preloadImages, { once: true });
          this.card.addEventListener('pointerdown', this.preloadImages, { once: true });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);

        if (this.card) {
          this.card.removeEventListener('pointerenter', this.preloadImages);
          this.card.removeEventListener('focusin', this.preloadImages);
          this.card.removeEventListener('pointerdown', this.preloadImages);
        }

        this.preloadedImages.clear();
        this.hasPreloadedImages = false;
        this.card = null;
        this.imageSwitchId += 1;
      }

      getPreloader(button, sizes) {
        const src = button.dataset.cvvImageSrc;
        if (!src) return null;

        const cachedImage = this.preloadedImages.get(src);
        if (cachedImage) return cachedImage;

        const preloader = new Image();
        preloader.decoding = 'async';
        preloader.srcset = button.dataset.cvvImageSrcset || '';
        preloader.sizes = sizes || '';
        preloader.src = src;
        this.preloadedImages.set(src, preloader);

        return preloader;
      }

      preloadImages() {
        if (this.hasPreloadedImages) return;
        this.hasPreloadedImages = true;

        const cardImage = this.card?.querySelector('[data-cvv-card-image], .cvv-product-card__image');
        const sizes = cardImage?.sizes || '';

        this.querySelectorAll('[data-cvv-variant-swatch]').forEach((button) => {
          if (button.getAttribute('aria-pressed') !== 'true') {
            this.getPreloader(button, sizes);
          }
        });
      }

      switchImage(image, button) {
        const nextSrc = button.dataset.cvvImageSrc;
        const nextSrcset = button.dataset.cvvImageSrcset || '';
        if (!nextSrc || image.getAttribute('src') === nextSrc) return;

        const switchId = ++this.imageSwitchId;
        image.classList.remove('is-switching');

        const preloader = this.getPreloader(button, image.sizes);
        if (!preloader) return;

        const revealImage = () => {
          if (switchId !== this.imageSwitchId) return;

          const updateSource = () => {
            if (switchId !== this.imageSwitchId) return;
            image.srcset = nextSrcset;
            image.src = nextSrc;
            image.alt = button.dataset.cvvImageAlt || '';

            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                if (switchId === this.imageSwitchId) image.classList.remove('is-switching');
              });
            });
          };

          if (this.reducedMotion.matches) {
            updateSource();
            return;
          }

          let sourceUpdated = false;
          const updateOnce = () => {
            if (sourceUpdated) return;
            sourceUpdated = true;
            updateSource();
          };

          image.addEventListener(
            'transitionend',
            (transitionEvent) => {
              if (transitionEvent.propertyName === 'opacity') updateOnce();
            },
            { once: true }
          );
          image.classList.add('is-switching');
          window.setTimeout(updateOnce, 220);
        };

        if (preloader.complete && preloader.naturalWidth > 0) {
          revealImage();
        } else {
          preloader.addEventListener('load', revealImage, { once: true });
        }
      }

      handleClick(event) {
        const button = event.target.closest('[data-cvv-variant-swatch]');
        if (!button || !this.contains(button)) return;

        const card = this.closest('.cvv-product-card');
        if (!card) return;

        const image = card.querySelector('[data-cvv-card-image], .cvv-product-card__image');
        if (image) this.switchImage(image, button);

        const variantUrl = button.dataset.cvvVariantUrl;
        if (variantUrl) {
          card.querySelectorAll('[data-cvv-card-link]').forEach((link) => {
            link.href = variantUrl;
          });

          const quickAddButton = card.querySelector('.cvv-product-card__quick-add-button[data-product-url]');
          if (quickAddButton) quickAddButton.dataset.productUrl = variantUrl;
        }

        this.querySelectorAll('[data-cvv-variant-swatch]').forEach((swatch) => {
          const selected = swatch === button;
          swatch.classList.toggle('is-active', selected);
          swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }
    }

    customElements.define('cvv-variant-swatches', CvvVariantSwatches);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
